import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import DetailFooter from './DetailFooter.js';

const DetailFooterContainer = (_param)=>{
    var detailFooterProps = swcHelpers.extends({}, _param);
    const { getLabel , currency  } = useIntl();
    const labels = {
        additionalDiscount: getLabel('common.additionalDiscount'),
        free: getLabel('common.free'),
        shipping: getLabel('common.shipping'),
        subtotal: getLabel('common.subtotal'),
        total: getLabel('common.total')
    };
    return /*#__PURE__*/ React.createElement(DetailFooter, swcHelpers.extends({}, detailFooterProps, {
        currency: currency,
        labels: labels
    }));
};
var DetailFooterContainer$1 = DetailFooterContainer;

export { DetailFooterContainer$1 as default };
//# sourceMappingURL=DetailFooterContainer.js.map
